<section class="footer-section w-100 w-100-mob">
  <div class="higher-inner footer-section mt-4 pt-6 d-flex br-2px-black container container-mob rounded-4 position-relative">
    <div class="access-div d-inline-block ps-8 pl-0">
      <div class="d-inline-block">
        <h3 class="ls-02em mb-0 fw-medium f-col">Access</h3></div>
      <br>
      <div class="d-inline-block">
        <h4 class="contact m-0 cursor-pointer col-grey font-outfit fw-normal">Contact</h4></div>
      <br>
      <div class="d-inline-block"><a routerLink="/signin">
        <h4 class="sign-in cursor-pointer col-grey font-outfit m-0 fw-normal">Sign&nbsp;In</h4></a></div>
      <br>
      <div class="d-inline-block"><a routerLink="/signup">
        <h4 class="sign-up cursor-pointer col-grey font-outfit m-0 fw-normal">Sign&nbsp;Up&nbsp;Free</h4></a>
      </div>
    </div>
    <div class="ml-35px ms-8 d-inline-block">
      <div class="d-inline-block"><h3 class="ls-02em mb-0 fw-medium f-col">Company</h3></div>
      <br>
      <div class="d-inline-block"><a href="/privacy-policy">
        <h4 class="privacy cursor-pointer col-grey font-outfit m-0 fw-normal">Privacy&nbsp;Policy</h4></a></div>
      <br>
      <div class="d-inline-block"><a href="/terms-conditions">
        <h4 class="terms cursor-pointer col-grey font-outfit m-0 fw-normal">Terms&nbsp;of&nbsp;Conditions</h4></a>
      </div>
      <br>
      <span>&nbsp;</span>
    </div>
    <div class="logo-icons mr-255">
      <img class="itspace-logo d-inline-block position-absolute"
           src="/assets/images/brand/logo/logo-itspace.png" alt="itspace-logo">
      <img class="insta-icon position-absolute d-inline-block z-5"
           src="./assets/images/brand/insta.png" alt="insta-icon">
      <div class="first-icon position-absolute d-inline-block br-2px-black"></div>
      <img class="facebook-icon position-absolute d-inline-block z-5"
           src="./assets/images/brand/facebook.png" alt="facebook-icon">
      <div class="second-icon position-absolute d-inline-block br-2px-black"></div>
      <img class="linkedin-icon position-absolute d-inline-block z-5"
           src="./assets/images/brand/linkedin.png" alt="linkedin-icon">
      <div class="third-icon position-absolute d-inline-block br-2px-black"></div>
      <img class="tiktok-icon position-absolute d-inline-block z-5"
           src="./assets/images/brand/tiktok.png" alt="tiktok-icon">
      <div class="forth-icon position-absolute d-inline-block br-2px-black"></div>
      <img class="youtube-icon position-absolute d-inline-block z-5"
           src="./assets/images/brand/youtube.png" alt="youtube-icon">
      <div class="fifth-icon position-absolute d-inline-block br-2px-black"></div>
    </div>
  </div>
  <div class="lower-footer d-flex justify-content-center align-items-center pb-5 pt-5">
    <div class="d-flex flex-row justify-content-between w-100 container-mob rights-container">
      <div class="not-mobile-div ps-8 pl-0">
        <img src="/assets/images/background/itquiz-footer.png" alt="quiz" class="it-quiz">
      </div>
      <div class="reserved-rights justify-content-end pe-7 pt-1 d-flex">
        <h4 class="m-0 fw-normal f-col">©&nbsp;2024&nbsp;All&nbsp;rights&nbsp;reserved</h4></div>
    </div>
  </div>
</section>
